import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullToEmpty'
})
export class NullToEmptyPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    return value.toLowerCase().includes('null') ? '' : value.trim();
  }

}
